import React, { useEffect, useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { ListingCard, ListingCardProps } from './ListingCard';
interface ListingCarouselProps {
  listings: ListingCardProps[];
}
export function ListingCarousel({
  listings
}: ListingCarouselProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const updateScrollState = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 8);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 8);
  };
  useEffect(() => {
    updateScrollState();
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateScrollState, {
      passive: true
    });
    window.addEventListener('resize', updateScrollState);
    return () => {
      el.removeEventListener('scroll', updateScrollState);
      window.removeEventListener('resize', updateScrollState);
    };
  }, [listings]);
  const scrollBy = (dir: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8;
    el.scrollBy({
      left: dir === 'left' ? -amount : amount,
      behavior: 'smooth'
    });
  };
  return <div className="relative group/carousel" data-id="element-1854">
      {/* Edge fades — premium affordance signalling more cards sideways */}
      <div className={`hidden md:block pointer-events-none absolute left-0 top-0 bottom-4 w-16 z-10 bg-gradient-to-r from-white to-transparent transition-opacity duration-300 ${canScrollLeft ? 'opacity-100' : 'opacity-0'}`} data-id="element-1855" />
      <div className={`hidden md:block pointer-events-none absolute right-0 top-0 bottom-4 w-16 z-10 bg-gradient-to-l from-white to-transparent transition-opacity duration-300 ${canScrollRight ? 'opacity-100' : 'opacity-0'}`} data-id="element-1856" />

      {/* Left Arrow */}
      <button onClick={() => scrollBy('left')} aria-label="Previous listings" className={`hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center bg-white rounded-full shadow-medium border border-slate-100 text-slate-700 hover:text-primary-indigo transition-all ${canScrollLeft ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-1857">
        <ChevronLeftIcon className="w-5 h-5" data-id="element-1858" />
      </button>

      {/* Right Arrow */}
      <button onClick={() => scrollBy('right')} aria-label="Next listings" className={`hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center bg-white rounded-full shadow-medium border border-slate-100 text-slate-700 hover:text-primary-indigo transition-all ${canScrollRight ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-1859">
        <ChevronRightIcon className="w-5 h-5" data-id="element-1860" />
      </button>

      {/* Scroll Track */}
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto pb-4 snap-x snap-proximity no-scrollbar" data-id="element-1861">
        {listings.map(listing => <div key={listing.id} id={`listing-${listing.id}`} className="snap-start flex-shrink-0 w-[250px] sm:w-[280px] rounded-2xl transition-all" data-id="element-1862">
            <ListingCard {...listing} data-id="element-1863" />
          </div>)}
      </div>
    </div>;
}